import { render, staticRenderFns } from "./pre.vue?vue&type=template&id=4d274c18&scoped=true"
import script from "./pre.vue?vue&type=script&lang=js"
export * from "./pre.vue?vue&type=script&lang=js"
import style0 from "./pre.vue?vue&type=style&index=0&id=4d274c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d274c18",
  null
  
)

export default component.exports